import Vue from 'vue'
import Router from 'vue-router'
import store from '../src/store.js'
// import Camera from './views/Camera.vue'

Vue.use(Router)

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import('./views/Login2.vue')
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('./views/Register.vue')
    },
    {
      path: '/forgot',
      name: 'forgot',
      component: () => import('./views/Forgot.vue')
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('./views/Home.vue'),
      beforeEnter: (to, from, next) => {
        if (store.state.logged_in) {
          next()
        } else {
          next({ path: '/' })
        }
      }
    },
    {
      path: '/camera',
      name: 'camera',
      component: () => import('./views/Camera.vue'),
      beforeEnter: (to, from, next) => {
        if (store.state.logged_in) {
          next()
        } else {
          next({ path: '/' })
        }
      }
    },
    {
      path: '/grill',
      name: 'grill',
      component: () => import('./views/Grill.vue'),
      beforeEnter: (to, from, next) => {
        if (store.state.logged_in) {
          next()
        } else {
          next({ path: '/' })
        }
      }
    },
    {
      path: '/submit',
      name: 'submit',
      component: () => import('./views/Submit.vue'),
      beforeEnter: (to, from, next) => {
        if (store.state.logged_in) {
          next()
        } else {
          next({ path: '/' })
        }
      }
    },
    {
      path: '/confirm',
      name: 'confirm',
      component: () => import('./views/Confirm.vue'),
      beforeEnter: (to, from, next) => {
        if (store.state.logged_in) {
          next()
        } else {
          next({ path: '/' })
        }
      }
    },
    {
      path: '/page/:slug',
      props: true,
      name: 'page-template',
      component: () => import('./views/PageTemplate.vue')
    },
    {
      path: '*',
      component: () => import('./views/Home.vue'),
      beforeEnter: (to, from, next) => {
        if (store.state.logged_in) {
          next()
        } else {
          next({ path: '/' })
        }
      }
    }
  ]
})
